import branditRails from '../../../../api/brandit_rails'
import {
  setValidationStatusAction,
  setValidationErrorsAction,
  clearValidationErrorsAction,
  setCheckoutErrorsAction
} from './checkout.actions'

/**
 * POST /checkout_validation - Validate checkout state on backend before proceeding
 * @param {string} token - Checkout session token
 * @param {Object} params - Validation parameters
 * @param {string} params.stage - Validation stage ('proceed_to_checkout' | 'place_order')
 * @param {Array} params.cartItems - Cart items to validate
 * @param {Array} params.multiAddressSelection - Multi-address selections
 * @returns {Promise<{valid: boolean, errors?: Array}>}
 */
export const validateCheckoutOnServer = (token, { stage, cartItems, multiAddressSelection }) => async dispatch => {
  try {
    dispatch(setValidationStatusAction('loading'))
    dispatch(clearValidationErrorsAction())

    const { data } = await branditRails.post('/checkout_validation', {
      checkout_session_token: token,
      stage,
      cart_items: cartItems,
      checkout_session_data: {
        multi_address_selection: multiAddressSelection
      }
    })

    // Response format: { success, data: { valid }, errors, message }
    dispatch(setValidationStatusAction('succeeded'))
    return { valid: data.data?.valid ?? true, errors: null }
  } catch (err) {
    const response = err.response?.data

    if (err.response?.status === 422) {
      // Response format: { success: false, errors: [...], message }
      const errors = response?.errors || []
      dispatch(setValidationStatusAction('failed'))
      dispatch(setValidationErrorsAction(errors))
      return { valid: false, errors }
    }

    // Unexpected error - log but don't block checkout
    console.error('Checkout validation error:', err)
    dispatch(setValidationStatusAction('failed'))
    dispatch(
      setCheckoutErrorsAction({
        action: 'validateCheckoutOnServer',
        message: response?.message || err.message || 'Failed to validate checkout'
      })
    )
    return { valid: true, errors: null }
  }
}

/** Convenience wrapper for proceed_to_checkout stage validation */
export const validateProceedToCheckout = (token, { cartItems, multiAddressSelection }) =>
  validateCheckoutOnServer(token, { stage: 'proceed_to_checkout', cartItems, multiAddressSelection })
